import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function StarekPlansModal(props) {
  return (
    <Modal show={props.show} onHide={props.handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>View Plans</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-4 d-flex align-items-stretch">
            <div className="card border rounded p-3 w-100">
              <div className="d-flex justify-content-between mb-3">
                <div className="font-weight-normal">Basic Plan</div>
                <div className="font-weight-bold">Free</div>
              </div>
              <div>
                <i className="far fa-check-circle mr-2"></i>Unlimited Devices
              </div>
              <div>
                <i className="far fa-check-circle mr-2"></i>Upto 10 active
                plants
              </div>
              <div>
                <i className="far fa-check-circle mr-2"></i>Upto 10 active
                plants
              </div>
              <div className="text-primary text-center mt-auto">
                Currently Applied!
              </div>
            </div>
          </div>
          <div className="col-4 d-flex align-items-stretch">
            <div className="card border rounded text-center p-3 w-100">
              <div className="d-flex justify-content-between mb-3">
                <div className="font-weight-normal">Plan Name</div>
                <div className="font-weight-bold">Price</div>
              </div>
              <div className="text-start mb-4">
                <div>
                  <i className="far fa-check-circle mr-2"></i>Unlimited Devices
                </div>
                <div>
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div>
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div>
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div>
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
              </div>
              <div className="btn btn-primary mt-auto">Upgrade Plan</div>
            </div>
          </div>
          <div className="col-4 d-flex align-items-stretch">
            <div className="card border rounded text-center p-3 w-100">
              <div className="d-flex justify-content-between mb-3">
                <div className="font-weight-normal">Plan Name</div>
                <div className="font-weight-bold">Price</div>
              </div>
              <div className="text-start mb-4">
                <div className="text-start">
                  <i className="far fa-check-circle mr-2"></i>Unlimited Devices
                </div>
                <div className="text-start">
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div className="text-start">
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div className="text-start">
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div className="text-start">
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
                <div className="text-start">
                  <i className="far fa-check-circle mr-2"></i>Upto 10 active
                  plants
                </div>
              </div>
              <div className="btn btn-outline-primary mt-auto">
                Upgrade Plan
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
export default StarekPlansModal;
